import { Box } from "@mui/material";
import MainLayout from "Layouts/AppContainer/Layout";
import Button from "components/common/Button";
import CustomModal from "components/common/Modal/CustomModal";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { clearUserLoggedIn } from "redux-store/features/Auth/Login";
import { ReduxState } from "../../constants/config/appointmentsDashboard.type";

const PrivateRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const { loggedIn, userWasLoggedIn, isAuthorized } = useSelector((state: ReduxState) => state.auth);

  useEffect(() => {
    if (!loggedIn || !isAuthorized) {
      if (userWasLoggedIn) {
        setShowModal(true);
      } else {
        navigate("/login?logged_out=1");
      }
    }
  }, [loggedIn, userWasLoggedIn, navigate, isAuthorized]);

  const handleOkClick = () => {
    dispatch(clearUserLoggedIn());
    setShowModal(false);
    navigate("/login?logged_out=1");
  };

  return (
    <>
      <CustomModal
        open={showModal}
        title="Session Expired"
        maxWidth="sm"
        fade={true}
        showCloseIcon={false}
        actions={[
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Button onClick={handleOkClick} text={"Ok"} />
          </Box>,
        ]}
        sxDialog={{
          "& .MuiDialog-paper": {
            maxWidth: "400px",
          },
        }}
        sxDialogContent={{
          padding: "0px",
          minWidth: "auto",
        }}>
        <Box sx={{ padding: "15px" }}>Your session has ended. Please login again.</Box>
      </CustomModal>

      <MainLayout>
        <Outlet />
      </MainLayout>
    </>
  );
};

export default PrivateRoute;
